// src/lib/pdfMetadata.js
// Marks downloaded PDFs as containing AI-generated text, in the file's own
// metadata (machine-readable), as the EU AI Act transparency rules expect.
// The visible disclaimer on the report says the same thing in plain words.

export const AI_PDF_PROPERTIES = {
  title: 'ApptNote appointment report',
  subject: 'Personal symptom summary prepared from my own logs. Contains AI-generated text. Not a diagnosis or medical advice.',
  author: 'Prepared by the user with ApptNote',
  keywords: 'AI-generated, ApptNote, symptom log',
  creator: 'ApptNote (text drafted by AI from the user\'s own logs)',
};

export function markPdfAsAiGenerated(pdf) {
  if (pdf && typeof pdf.setProperties === 'function') pdf.setProperties(AI_PDF_PROPERTIES);
  return pdf;
}
